/* eslint-disable import/prefer-default-export */
import { useQuery } from "@tanstack/react-query";
import { getQuickRequests } from "api/services/quickRequest";
import { quickRequestQueryKeys } from "./quickRequestQueryKeys";

export const useGetQuickList = (filters: any) =>
  useQuery({
    queryKey: quickRequestQueryKeys.quickRequestListing(filters),
    queryFn: ({ signal }) => getQuickRequests({ params: filters, signal }).then((res) => res.data),
  });
